import DialogWrapper from "@memorang/ui/components/DialogWrapper";
import { useKeyboard } from "@react-native-community/hooks";
import { useTranslation } from "react-i18next";
import { Dialog } from "react-native-paper";
import { dialogTexts } from "../constants";
import type { FaqsDialogProps } from "../types";
import FaqsContainer from "./FaqsContainer";

const FaqsDialog = ({ visible, handleClose }: FaqsDialogProps) => {
	const { t } = useTranslation();
	const { keyboardHeight } = useKeyboard();
	const config = dialogTexts.faqs;

	return (
		<DialogWrapper
			visible={visible}
			handleClose={handleClose}
			bottom={keyboardHeight ? keyboardHeight - 200 : 0}
		>
			<Dialog.Icon icon="message-question-outline" />
			<Dialog.Title style={{ textAlign: "center" }}>
				{t(config.title)}
			</Dialog.Title>
			<Dialog.Content>
				<FaqsContainer />
			</Dialog.Content>
		</DialogWrapper>
	);
};

export default FaqsDialog;
